import { AppState } from './app';
import * as constants from '../constants';
import { addToSSObject } from '../utils/react';
import {
  SchemaBasketCheckResponse,
  SchemaBasketcontentResponse,
  SchemaBasketDataResponse,
  SchemaBasketdefinitionResponse,
  SchemaBasketInfoResponse,
  SchemaNewBasketResponse,
  SchemaProduct,
  SchemaReserveBasketResponse,
} from '@repo/legacy-commerce-api';

// We type the payload cast inside each switch case:
export type BasketActionType = {
  type:
    | typeof constants.OPEN_BASKET
    | typeof constants.CLOSE_BASKET
    | typeof constants.SET_IS_BASKET_BOOKED
    | typeof constants.BASKET_DATA_POSTED
    | typeof constants.RESERVED_BASKET
    | typeof constants.CREATED_BASKET
    | typeof constants.BOOKED_BASKET
    | typeof constants.BASKET_CUSTOMER_POSTED
    | typeof constants.FETCHED_BASKET_STATE
    | typeof constants.FETCHED_BASKET_INFO
    | typeof constants.FETCHED_LAST_BOOKED_BASKET_INFO
    | typeof constants.CLEAR_BASKET_INFO
    | typeof constants.SET_BASKET_INFO
    | typeof constants.ADDED_TO_BASKET
    | typeof constants.EDIT_IN_BASKET
    | typeof constants.REMOVED_FROM_BASKET
    | typeof constants.FETCHED_BASKET_DEFINITION
    | typeof constants.FETCHED_BASKETJ2
    | typeof constants.FETCHED_BASKET
    | typeof constants.BASKET_SELECTION_UPDATED
    | typeof constants.CHOOSE_BASKET
    | typeof constants.UPDATE_DATE_DURATION
    | typeof constants.COPIED_BASKET_J3
    | typeof constants.ADDED_VOUCHER
    | typeof constants.DELETED_VOUCHER;
  payload: any;
  [key: string]: any;
};

export const basketReducer = (state: AppState, action: BasketActionType, initialUserDataEC: any) => {
  switch (action.type) {
    case constants.OPEN_BASKET: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          isBasketOpen: true,
        },
      };
    }

    case constants.CLOSE_BASKET: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          isBasketOpen: false,
        },
      };
    }

    case constants.SET_IS_BASKET_BOOKED: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          isBasketBooked: action.payload,
        },
      };
    }

    case constants.BASKET_DATA_POSTED: {
      const payload = action.payload as SchemaBasketDataResponse;

      addToSSObject('userDataEC', 'basketData', payload);

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketData: payload.data,
        },
      };
    }

    case constants.RESERVED_BASKET: {
      const { data } = action.payload as SchemaReserveBasketResponse;
      let newuserDataEC = JSON.parse((window as any).sessionStorage.getItem('userDataEC'));
      (newuserDataEC || state.userDataEC)['basketInfo']['reservationDetails'] = {
        ...data,
      };
      (window as any).sessionStorage.setItem('userDataEC', JSON.stringify(newuserDataEC));

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          shouldCreateNewBasketJ1: false,
          basketInfo: {
            ...state.userDataEC.basketInfo,
            reservationDetails: data,
          },
        },
      };
    }

    case constants.CREATED_BASKET: {
      const { data } = action.payload as SchemaNewBasketResponse;
      let newuserDataEC = JSON.parse((window as any).sessionStorage.getItem('userDataEC'));
      (newuserDataEC || state.userDataEC).basketInfo = data;
      (window as any).sessionStorage.setItem('userDataEC', JSON.stringify(newuserDataEC));
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketInfo: data,
          shouldCreateNewBasketJ2: false,
          basketProducts: {
            productsByUrn: {},
            productsById: {},
            productsByUrnDate: {}, // Neu
            productsByUrnAll: {}, // Neu
            products: [],
            stats: null,
          },
        },
      };
    }

    case constants.BOOKED_BASKET: {
      return {
        ...state,
        dataPrefilledJ3: false,
      };
    }

    case constants.BASKET_CUSTOMER_POSTED: {
      addToSSObject('userDataEC', 'basketData', action.payload);

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketCustomer: action.payload.data,
        },
      };
    }

    case constants.FETCHED_BASKET_STATE: {
      const { data } = action.payload as SchemaBasketCheckResponse;
      if (data.state == -1) {
        return {
          ...state,
          userDataEC: {
            ...initialUserDataEC,
          },
        };
      } else {
        return {
          ...state,
          userDataEC: {
            ...state.userDataEC,
            basketInfo: {
              ...state.userDataEC.basketInfo,
              ...data,
            },
          },
        };
      }
    }

    case constants.FETCHED_BASKET_INFO: {
      const { data } = action.payload as SchemaBasketInfoResponse;

      // custom payload from reducer:
      const oldBasketInfo = action.payload.oldBasketInfo;
      const newBasketInfo = { ...oldBasketInfo, ...data };
      addToSSObject('userDataEC', 'basketInfo', newBasketInfo);

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketInfo: {
            ...state.userDataEC.basketInfo,
            ...data,
          },
        },
      };
    }

    case constants.FETCHED_LAST_BOOKED_BASKET_INFO: {
      const { data } = action.payload as SchemaBasketInfoResponse;
      const newBasketInfo = { ...data };
      addToSSObject('userDataEC', 'lastBookedBasketInfo', newBasketInfo);
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          lastBookedBasketInfo: {
            ...state.userDataEC.lastBookedBasketInfo,
            ...data,
          },
        },
      };
    }

    case constants.CLEAR_BASKET_INFO: {
      let newUserDataEC = JSON.parse((window as any).sessionStorage.getItem('userDataEC')) || initialUserDataEC;
      const defaultBasketProducts = {
        groupedProducts: [],
        products: [],
        productsById: {},
        productsByUrn: {},
        productsByUrnDate: {},
        productsByUrnAll: {},
        stats: null,
      };
      newUserDataEC.basketProducts = defaultBasketProducts;
      newUserDataEC.basketInfo = null;
      newUserDataEC.locations = {};
      newUserDataEC.industry = null;
      newUserDataEC.duration = null;
      newUserDataEC.startDate = null;

      (window as any).sessionStorage.setItem('userDataEC', JSON.stringify(newUserDataEC));

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketInfo: null,
          basketProducts: defaultBasketProducts,
          locations: {},
          industry: null,
          duration: null,
          startDate: null,
        },
      };
    }

    case constants.SET_BASKET_INFO: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketInfo: action.payload,
        },
      };
    }

    case constants.ADDED_TO_BASKET: {
      const codeName = '1006_App\\Shop\\Domain\\Exception\\BasketValidationException';
      const newErrors = { ...state.errors };
      newErrors[codeName] && delete newErrors[codeName];
      return {
        ...state,
        errors: { ...newErrors },
        userDataEC: {
          ...state.userDataEC,
          basketProducts: {
            ...state.userDataEC.basketProducts,
            productsByUrn: {
              ...state.userDataEC.basketProducts.productsByUrn,
              [action.payload.data.newentries[0].urn]: {
                ...action.payload.data.newentries[0],
                state: 0,
              },
            },
            productsByUrnDate: {
              ...state.userDataEC.basketProducts.productsByUrnDate,
              [action.payload.data.newentries[0].basketkey]: {
                ...action.payload.data.newentries[0],
                state: 0,
              },
            },
          },
        },
      };
    }

    case constants.EDIT_IN_BASKET: {
      const codeName = '1006_App\\Shop\\Domain\\Exception\\BasketValidationException';
      const newErrors = { ...state.errors };
      newErrors[codeName] && delete newErrors[codeName];
      const newProductsByUrn = {
        ...state.userDataEC.basketProducts.productsByUrn,
      };

      const newProductsByUrnDate = {
        ...state.userDataEC.basketProducts.productsByUrnDate,
      };

      newProductsByUrn[action.payload.urn] = action.payload.data;
      newProductsByUrnDate[action.payload.basketkey] = action.payload.data;
      return {
        ...state,
        errors: { ...newErrors },
        userDataEC: {
          ...state.userDataEC,
          basketProducts: {
            ...state.userDataEC.basketProducts,
            productsByUrn: {
              ...newProductsByUrn,
            },
            productsByUrnDate: {
              ...newProductsByUrnDate,
            },
          },
        },
      };
    }

    case constants.REMOVED_FROM_BASKET: {
      const newProductsByUrn = {
        ...state.userDataEC.basketProducts.productsByUrn,
      };

      const newProductsByUrnDate = {
        ...state.userDataEC.basketProducts.productsByUrnDate,
      };

      newProductsByUrn[action.payload.urn] && delete newProductsByUrn[action.payload.urn];
      newProductsByUrnDate[action.payload.basketkey] && delete newProductsByUrnDate[action.payload.basketkey];

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketProducts: {
            ...state.userDataEC.basketProducts,
            productsByUrn: {
              ...newProductsByUrn,
            },
            productsByUrnDate: {
              ...newProductsByUrnDate,
            },
          },
        },
      };
    }

    case constants.FETCHED_BASKET_DEFINITION: {
      const { data } = action.payload as SchemaBasketdefinitionResponse;
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketInfo: {
            ...state.userDataEC.basketInfo,
            definition: data,
          },
        },
      };
    }

    case constants.FETCHED_BASKETJ2: {
      let productsArray: SchemaProduct[] = [];
      let productsByUrn: Record<string, SchemaProduct> = {};
      let productsById: Record<string, SchemaProduct> = {};
      let groupedProductsByCity: Record<string, SchemaProduct> = {};
      let productsByUrnDate: Record<string, SchemaProduct> = {};
      let productsByUrnAll: Record<string, SchemaProduct[]> = {};

      const { data } = action.payload as SchemaBasketcontentResponse;

      data.groupedproducts.elements.forEach(({ subgroup }) => {
        // @ts-expect-error countinvalidstate does not exist on the OpenAPI spec on this level:
        subgroup.elements.forEach(({ subgroup: { elements }, groupvalue, count, countinvalidstate }) => {
          const current = groupedProductsByCity[groupvalue];
          groupedProductsByCity[groupvalue] = current
            ? {
                ...current,
                // @ts-expect-error OpenApi error of TS 'unknown | unknown"
                count: current.count + count,
                // @ts-expect-error OpenApi error of TS 'unknown | unknown"
                elements: [...current.elements, ...elements],
                countinvalidstate: countinvalidstate,
              }
            : { groupvalue, count, elements, countinvalidstate };

          // @ts-expect-error product does not exist on the OpenAPI spec on this level:
          elements.forEach(({ products }) => {
            products.forEach((product: SchemaProduct) => {
              // List nach URN + Datum
              let urnDateKey = product.basketkey;

              if (!urnDateKey) {
                urnDateKey = `${product.producturn}_${product.basketstartdate.split('T')[0]}`;
              }
              productsByUrnDate[urnDateKey] = product;
              // List by basket entry id
              // @ts-expect-error basketentryId with Capitical I exist, spec mismatch:
              productsById[product.basketentryid] = product;
              productsArray.push(product);

              // all elements for on product urn
              if (!productsByUrnAll[product.producturn]) {
                productsByUrnAll[product.producturn] = [];
              }
              productsByUrnAll[product.producturn].push(product);
              // List for first element of producturn
              // needed for compatability reasons
              productsByUrn[product.producturn] = product;
            });
          });
        });
      });

      const basketProducts = {
        productsByUrn,
        productsById,
        productsByUrnDate,
        productsByUrnAll,
        products: [...productsArray],
        groupedProductsByCity,
        groupedProducts: data.groupedproducts.elements,
        stats: data.summary,
      };

      let basketInfo = state.userDataEC.basketInfo;

      if (data.customer) {
        basketInfo = {
          ...basketInfo,
          customer: data.customer,
        };
      }

      if (data.possiblecategories) {
        basketInfo = {
          ...basketInfo,
          possiblecategories: data.possiblecategories,
        };
      }

      if (data.category) {
        basketInfo = {
          ...basketInfo,
          category: data.category,
        };
      }

      let newUserDataEC = JSON.parse((window as any).sessionStorage.getItem('userDataEC')) || initialUserDataEC;
      newUserDataEC.basketProducts = basketProducts;
      (window as any).sessionStorage.setItem('userDataEC', JSON.stringify(newUserDataEC));

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketInfo,
          shouldCreateNewBasketJ2: false,
          basketProducts,
          invalidProductsJ3: data.countstateinvalid,
        },
      };
    }

    // Don't type: Legacy J1 FETCHED_BASKET Reducer:
    case constants.FETCHED_BASKET: {
      let productsByUrn = {};
      let productsById = {};
      let productsByUrnDate = {};
      let productsByUrnAll = {};
      let iteratable = [];
      if (action.payload.data.groupedproducts.elements) {
        action.payload.data.groupedproducts.elements.forEach((locationLevel, idx) => {
          locationLevel.subgroup.elements.forEach((formatLevel) => {
            iteratable.push(...formatLevel.products);
          });
        });
      } else {
        iteratable.push(...action.payload.data.groupedproducts.products);
      }

      iteratable.forEach((product, idx) => {
        productsByUrn[product.producturn] = product;
        productsById[product.basketentryid] = product;
        productsByUrnDate[product.basketkey] = product;
        if (!productsByUrnAll[product.producturn]) {
          productsByUrnAll[product.producturn] = [];
        }
        productsByUrnAll[product.producturn].push(product);
      });

      // Can't save individual products to SS as it exceeds quota
      let ssBaskets = JSON.parse((window as any).sessionStorage.getItem('ecState')).baskets;
      addToSSObject('ecState', 'baskets', {
        ...ssBaskets,
        [action.payload.basket]: {
          basketId: action.payload.basket,
          stats: action.payload.data.summary,
        },
      });

      return {
        ...state,
        baskets: {
          ...state.baskets,
          [action.payload.basket]: {
            ...action.payload.data,
            productsByUrn: { ...productsByUrn },
            productsById: { ...productsById },
            productsByUrnDate: { ...productsByUrnDate },
            productsByUrnAll: { ...productsByUrnAll },
            products: iteratable,
            stats: action.payload.data.summary,
          },
        },
        userDataEC: {
          ...state.userDataEC,
          shouldCreateNewBasketJ1: false,
          basketProducts: {
            productsByUrn: { ...productsByUrn },
            productsById: { ...productsById },
            productsByUrnDate: { ...productsByUrnDate },
            productsByUrnAll: { ...productsByUrnAll },
            products: iteratable,
            stats: action.payload.data.summary,
          },
        },
      };
    }

    // Don't type: Legacy J1/Step 7 BASKET_SELECTION_UPDATED Reducer:
    case constants.BASKET_SELECTION_UPDATED: {
      const newBaskets = state.baskets;
      let newProductsById = {};
      let newProductsByUrn = {};
      let newProductsByUrnDate = {};
      let newProductsByUrnAll = {};
      let newProposalsObj = { ...state.proposalsObj };
      newProposalsObj[action.payload.basket].totalcount = action.payload.data.basketstatistics.countmedia;
      newProposalsObj[action.payload.basket].totalsum = action.payload.data.basketstatistics.summedia;

      newBaskets[action.payload.basket].summary.mediacount = action.payload.data.basketstatistics.countmedia;
      newBaskets[action.payload.basket].summary.mediasum = action.payload.data.basketstatistics.summedia;

      action.payload.productIds.forEach((productId) => {
        newProductsById = {
          ...state.userDataEC.chosenBasketProducts.productsById,
        };
        newProductsByUrn = {
          ...state.userDataEC.chosenBasketProducts.productsByUrn,
        };
        newProductsByUrnDate = {
          ...state.userDataEC.chosenBasketProducts.productsByUrnDate,
        };
        newProductsByUrnAll = {
          ...state.userDataEC.chosenBasketProducts.productsByUrnAll,
        };
        newProductsById[productId].state = action.payload.state;

        newProductsByUrn[newProductsById[productId]['producturn']].state = action.payload.state;
        newProductsByUrnDate[newProductsById[productId]['basketkey']].state = action.payload.state;
        newProductsByUrnAll[newProductsById[productId]['producturn']].forEach((product) => {
          product.state = action.payload.state;
        });
      });

      addToSSObject('ecState', 'proposalsObj', newProposalsObj);

      return {
        ...state,
        proposalsObj: {
          ...newProposalsObj,
        },
        baskets: {
          ...newBaskets,
        },
        userDataEC: {
          ...state.userDataEC,
          chosenBasketProducts: {
            ...state.userDataEC.chosenBasketProducts,
            productsById: { ...newProductsById },
            productsByUrn: { ...newProductsByUrn },
            productsByUrnDate: { ...newProductsByUrnDate },
            productsByUrnAll: { ...newProductsByUrnAll },
          },
        },
      };
    }

    // Don't type: Legacy J1/Step 7 CHOOSE_BASKET Reducer:
    case constants.CHOOSE_BASKET: {
      addToSSObject('userDataEC', 'chosenProposal', action.payload.proposal);
      addToSSObject('userDataEC', 'selectedBasketProposal', action.payload.id);
      const chosenBasketProducts = {
        productsByUrn: {
          ...state.baskets[action.payload.proposal.basket].productsByUrn,
        },
        products: [...state.baskets[action.payload.proposal.basket].products],
        productsById: {
          ...state.baskets[action.payload.proposal.basket].productsById,
        },
        productsByUrnDate: {
          ...state.baskets[action.payload.proposal.basket].productsByUrnDate,
        },
        productsByUrnAll: {
          ...state.baskets[action.payload.proposal.basket].productsByUrnAll,
        },
      };
      addToSSObject('userDataEC', 'chosenBasketProducts', chosenBasketProducts);
      let analog = {};
      let digital = {};
      let traffic = {};
      let surface = {};
      [...state.baskets[action.payload.proposal.basket].products].forEach((product) => {
        if (product.producttype === 'analog') {
          analog[product.format] = true;
        } else if (product.producttype === 'digital') {
          digital[product.format] = true;
        } else {
          traffic[product.format] = true;
        }

        if (product.attributeshortcuts === 'L') {
          surface['Leuchtend (L)'] = true;
        } else if (product.attributeshortcuts === 'LR') {
          surface['Leuchtend / Rotierend (LR)'] = true;
        } else {
          surface['Normalplakat'] = true;
        }
      });

      return {
        ...state,
        availableAttributesJ1: { analog, digital, traffic, surface },
        userDataEC: {
          ...state.userDataEC,
          selectedBasketProposal: action.payload.id,
          chosenProposal: action.payload.proposal,
          chosenBasketProducts: {
            ...chosenBasketProducts,
          },
        },
      };
    }

    case constants.UPDATE_DATE_DURATION: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketProducts: {
            ...state.userDataEC.basketProducts,
            productsByUrn: {
              ...state.userDataEC.basketProducts.productsByUrn,
              [action.payload.producturn]: {
                ...state.userDataEC.basketProducts.productsByUrn[action.payload.producturn],
                startdate: action.payload.startdate,
                duration: action.payload.duration,
              },
            },
            productsByUrnDate: {
              ...state.userDataEC.basketProducts.productsByUrnDate,
              [action.payload.producturn]: {
                ...state.userDataEC.basketProducts.productsByUrnDate[action.payload.producturn],
              },
            },
          },
        },
      };
    }

    case constants.COPIED_BASKET_J3: {
      addToSSObject('userDataEC', 'basketInfo', action.payload.data);

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          basketInfo: action.payload.data,
          shouldCreateNewBasketJ2: false,
        },
      };
    }

    case constants.ADDED_VOUCHER: {
      const codeName = '-1_App\\Shop\\Domain\\Exception\\GutscheinException';
      const newErrors = { ...state.errors };
      newErrors[codeName] && delete newErrors[codeName];

      addToSSObject('userDataEC', 'vouchers', [...state.userDataEC.vouchers, action.posted]);
      addToSSObject('userDataEC', 'voucherInfo', action.payload.data);
      return {
        ...state,
        errors: { ...newErrors },
        userDataEC: {
          ...state.userDataEC,
          vouchers: [...state.userDataEC.vouchers, action.posted],
          voucherInfo: action.payload.data,
        },
      };
    }

    case constants.DELETED_VOUCHER: {
      addToSSObject('userDataEC', 'vouchers', []);
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          vouchers: [],
          voucherInfo: null,
        },
      };
    }
  }
};
